<template>
  <div class="job-detail-container">
    <div class="header d-flex justify-content-between align-items-center px-3">
      <h2 class="title">{{ $t("feature.homecare.job_detail") }}</h2>
      <a class="clock" @click="showModal = true">
        <img src="/static/icons/icon-history.svg" />
      </a>
    </div>
    <div class="job-detail px-3">
      <div class="information pt-3">
        <div class="item">
          <div class="label">{{ $t("feature.homecare.inform_name") }}</div>
          <div class="value">{{ fullname || "-" }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t("feature.homecare.house_number") }}</div>
          <div class="value">{{ job.info.address || "-" }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t("feature.homecare.project") }}</div>
          <div class="value">{{ job.info.projectName || "-" }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t("feature.homecare.insurance_status") }}</div>
          <div
            class="value"
            v-if="typeof job.info.homeWarrantyStatus === 'undefined'"
          >
            -
          </div>
          <div class="value" v-else>
            {{ job.info.homeWarrantyStatus ? "อยู่ในประกัน" : "ประกันหมดแล้ว" }}
          </div>
        </div>
        <div class="item">
          <div class="label">{{ $t("feature.homecare.owner_status") }}</div>
          <div class="value" v-if="job.info.userRole">
            {{ $t("owner." + job.info.userRole.toLowerCase()) }}
          </div>
          <div class="value" v-else>-</div>
        </div>
        <div class="item">
          <div class="label">{{ $t("feature.homecare.contact") }}</div>
          <div class="value">
            <div v-if="job.info.mobileNumber">
              {{ job.info.mobileNumber || "-" }}
            </div>
            <div v-if="job.info.email">{{ job.info.email }}</div>
            <div v-if="!job.info.email && !job.info.mobileNumber">-</div>
          </div>
        </div>
        <div class="item">
          <div class="label">{{ $t("feature.homecare.note") }}</div>
          <div class="value">
            {{ job.request_remark || "-" }}
          </div>
        </div>
      </div>
      <appointment-timeline :appointments="job.appointments" />
      <assessment-result :job="job" />
      <job-history-modal
        v-if="showModal"
        @isShow="onModalChange"
        :job-id="job.job_order_id"
        :project-id="$route.params.projectId"
      />
    </div>
  </div>
</template>

<script>
import AppointmentTimeline from "./AppointmentTimeline";
import AssessmentResult from "./AssessmentResult";
import JobHistoryModal from "./JobHistoryModal";

export default {
  props: {
    job: {}
  },
  components: {
    AppointmentTimeline,
    AssessmentResult,
    JobHistoryModal
  },
  computed: {
    fullname() {
      let name = "";
      name += this.job.info.firstName || "";
      if (this.job.info.lastName) {
        name += ` ${this.job.info.lastName}`;
      }
      return name;
    }
  },
  data() {
    return {
      showModal: false,
      appointments: [
        {
          appointment_code: "CLS",
          appointment_date: "2018-08-12T03:11:00Z"
        },
        {
          appointment_code: "RVW",
          appointment_date: "2018-08-25T13:10:00Z"
        },
        {
          appointment_code: "INP",
          appointment_date: "2018-07-08T13:10:00Z"
        },
        {
          appointment_code: "OPN",
          appointment_date: "2018-06-11T04:20:00Z"
        }
      ]
    };
  },
  methods: {
    onModalChange(state) {
      this.showModal = state;
    }
  }
};
</script>

<style lang="scss" scoped>
.job-detail-container {
  background: white;
  padding: 0;
}
.header {
  border-bottom: 1px solid #e0e0e0;
  height: 65px;
  flex-shrink: 0;
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
  }
  a.clock {
    cursor: pointer;
  }
}
.job-detail {
  overflow: auto;
  .label {
    font-size: 11px;
    font-weight: 500;
    color: #8c8786;
  }
  .information {
    .item {
      padding-bottom: 16px;
    }
    .value {
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/homecare/JobDetail.vue